module.exports = __webpack_public_path__ + "img/passed-away-2-min.a19ba6fc.png";